import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import LandingPage from './pages/LandingPage/LandingPage';
import FirstProfile from './pages/FirstProfile/FirstProfile';
import Home from './pages/Home/Home';
import Header from './components/Header';
import HostDinnerLocation from './pages/HostDinnerLocation/HostDinnerLocation';
import HostDinnerDetails from './pages/HostDinnerDetails/HostDinnerDetails';
import About from './pages/About/About';
import Profile from './pages/Profile/Profile';
import HostDinnerIntro from './pages/HostDinnerIntro/HostDinnerIntro';
import SignupSuccess from './components/SignupSuccess';
import HostDinnerAddress from "./pages/HostDinnerAddress/HostDinnerAddress";
import { Toaster } from 'react-hot-toast';


// ScrollToTop component - scrolls to top on route change
function ScrollToTop() {
    const { pathname } = useLocation();
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    
    return null;
}

function LayoutWithHeader({ children, onOpenMobileFilterBar }) {
    return (
        <>
            <Header onOpenMobileFilterBar={onOpenMobileFilterBar} />
            {children}
        </>
    );
}

function App() {
    // הוספת סטייט לפתיחת הסיידבר
    const [showMobileFilterBar, setShowMobileFilterBar] = React.useState(false);
    return (
        <ErrorBoundary>
            <AuthProvider>
                <div className="App">
                    <Toaster position="top-center" reverseOrder={false} />
                    <Router>
                        <ScrollToTop />
                        <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/first-profile" element={<FirstProfile />} />
                        <Route path="/signup-success" element={<SignupSuccess />} />
                        <Route
                            path="/home"
                            element={
                                <LayoutWithHeader onOpenMobileFilterBar={() => setShowMobileFilterBar(true)}>
                                    <Home showMobileFilterBar={showMobileFilterBar} setShowMobileFilterBar={setShowMobileFilterBar} />
                                </LayoutWithHeader>
                            }
                        />
                        <Route
                            path="/profile"
                            element={
                                <LayoutWithHeader>
                                    <Profile />
                                </LayoutWithHeader>
                            }
                        />
                        <Route
                            path="/HostDinnerIntro"
                            element={
                                <LayoutWithHeader>
                                    <HostDinnerIntro />
                                </LayoutWithHeader>
                            }
                        />
                        <Route
                            path="/About"
                            element={
                                <LayoutWithHeader>
                                    <About />
                                </LayoutWithHeader>
                            }
                        />
                        {/* דף 404 */}
                        <Route path="*" element={<div>404 - Page Not Found</div>} />
                        <Route path="/HostDinnerDetails" element={
                            <LayoutWithHeader>
                                <HostDinnerDetails />
                            </LayoutWithHeader>
                        } />
                        <Route path="/HostDinnerAddress" element={
                            <LayoutWithHeader>
                                <HostDinnerAddress />
                            </LayoutWithHeader>
                        } />
                    </Routes>
                </Router>
            </div>
        </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;